import { render } from "./PostCardThumbnail.vue?vue&type=template&id=753816a0&scoped=true"
import script from "./PostCardThumbnail.vue?vue&type=script&lang=js"
export * from "./PostCardThumbnail.vue?vue&type=script&lang=js"

import "./PostCardThumbnail.vue?vue&type=style&index=0&id=753816a0&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-753816a0"]])

export default __exports__